<template>
    <div class="o-page">
        <div class="o-layout" :class="{'bg-gray-100' : this.$route.meta.bgGray}">
            <c-sidebar></c-sidebar>
            <div class="o-content">
                <c-topbar :class="{'o-topbar--hide-desktop' : !this.$route.meta.topbar}"></c-topbar>
                <c-loading-container :loading="loading">
                    <router-view></router-view>
                </c-loading-container>
            </div>
        </div>
        <c-toast-container></c-toast-container>
        <c-confirm-container></c-confirm-container>
    </div>
</template>

<script>
import CSidebar from '@components/layout/Sidebar';
import CTopbar from '@components/layout/Topbar';
import CToastContainer from '@components/toast/Container';
import CConfirmContainer from '@components/confirm/Container';
import CLoadingContainer from '@components/loader/Container';

export default {
    components: { CSidebar, CTopbar, CToastContainer, CConfirmContainer, CLoadingContainer },
    data() {
        return {
            loading: true
        }
    },
    methods: {
        
    },
    mounted() {
        this.loading = false;
    },
    async created() {
        await this.$store.dispatch('permissions/load');
    },

}
</script>
